import { Component, inject, Input } from '@angular/core';
import { PageContainerComponent } from '../../../layout/page-container/page-container.component';
import { DynamicFormArray, FIELD_TYPES, FieldSelectedValue, Props} from '../../../model/form.model';
import { DataTableSchema } from '../../../model/dynamic-data-table.model';
import { FieldNames } from '../../../model/form-fields.model';
import { OptionsFetchConfig } from '../../../model/common.model';
import { BaseComponent } from '../../base/base.component';
import { CommonUtils } from '../../../utils/common.utils';
import { API_STATUS, ApiEnvNames, ERROR_RESPONSE, SearchConfig } from '../../../model/api.model';
import { CommonService } from '../../../services/common.service';
import { EventReportDynamicOptionFields, EventReportFormArray, EventReportTableSchema, EventSearchGetConfig } from '../../../model/event-registration-report.model';


@Component({
  selector: 'app-event-registration-report',
   standalone: true,
  imports: [PageContainerComponent],
  templateUrl: './event-registration-report.component.html',
  styleUrl: './event-registration-report.component.scss'
})
export class EventRegistrationReportComponent extends BaseComponent {

  protected data = 'EventReportComponent';
  public dataTableSchema: DataTableSchema = structuredClone(EventReportTableSchema);
  public filterSchema: DynamicFormArray = structuredClone(EventReportFormArray);
  protected props: Props = {};
  dynamicOptionFields: OptionsFetchConfig = EventReportDynamicOptionFields;
  title = '';
  commonUtils = inject(CommonUtils);
  service = inject(CommonService);
  public venues: any;
  datesByVenue: any[] = [];
  @Input() eventId!: number;

  override ngOnInit() {
    this.getData();
    super.ngOnInit();
    super.commonFunction();
    this.onSearchClicked(EventSearchGetConfig);
  }

  getData = () => {
    this.setTableLoadingState(true);
    this.dynamicOptionFields.searchConfig.body.eventId = this.eventId;
    this.service.getDataFromDataSource(this.dynamicOptionFields.searchConfig,ApiEnvNames['EventDashboard']).then((response) => {
        if (response['status'] === API_STATUS['Success']) {
          if (Array.isArray(response.result)) {
            this.datesByVenue = response.result[0]?.datesByVenue;
            this.filterSchema.FieldsArray.forEach((field) => {
              if (field['fieldName'] === FieldNames.Venue) {
                field.options = response.result[0]?.venues?.map(
                  (item: any) => ({
                    fieldLabel: `${item.venue} (${item.count})`,
                    fieldValue: item.venue,
                  }),
                );
                field['isLoading'] = false;
              }
              if(field['fieldName'] === FieldNames.EventTitle  || field['fieldName'] === FieldNames.Area || field['fieldName'] === FieldNames.RegistrationStatus) {
              const dynamicKey = field.fieldName;
              const raw = response?.result?.[0]?.[dynamicKey];
              field.options = Array.isArray(raw) ? raw.map((item: any) => ({
                    fieldLabel:item,
                    fieldValue: item,
                  }))
                : [];
                field['isLoading'] = false;
              }
            });
          }
        } else {
          this.commonUtils.showMatSnackBar(ERROR_RESPONSE['errorFetch']);
        }
      })
      .catch((err) => {
        console.info(ERROR_RESPONSE['layoutErrorPrefix'], err);
      })
  };

  override onResetClicked = () => {
    this.disableEnableButtons(false);
    this.dataTableSchema = {
      ...this.dataTableSchema,
      inputFilter: '',
      dataSource: []
    }; 
    this.filterSchema.FieldsArray = this.filterSchema.FieldsArray.map((field) => ({ ...field, selectedValue: field['defaultValue'] }));
    this.onSearchClicked(structuredClone(EventSearchGetConfig));
  };

  override onSearchClicked = (searchParam: SearchConfig) => {
    this.setTableLoadingState(true);
    this.dataTableSchema.dataSource = [];
    this.resetSorting();
    this.filterSchema['FieldsArray'].forEach((field:any) => {
      if ( field['selectedValue'] && field['selectedValue'] !== null && field['selectedValue'] !== '') {
       searchParam['body'][field['fieldName']] = field['selectedValue'];
      } else if (field['fieldType'] === FIELD_TYPES.NUMBER) {
        searchParam['body'][field['fieldName']] = '';
      }
    });
    searchParam['body']['eventId'] = this.eventId;
    this.filterSchema['payload'] = searchParam['body'];
    this.service.getDataFromDataSource(searchParam, ApiEnvNames['EventDashboard']).then((response) => {
        if (response['status'] === API_STATUS['Success']) {
          if (Array.isArray(response.result)) {
            this.dataTableSchema.dataSource = response.result;
          }
        } else {
          this.dataTableSchema.dataSource = [];
          this.commonUtils.showMatSnackBar(ERROR_RESPONSE['errorFetch']);
        }
        this.setTableLoadingState(false);
      })
      .catch((err) => {
        this.setTableLoadingState(false);
        this.dataTableSchema.dataSource = [];
        console.info(err);
      })
  };

override onControlValueChanged = (event: FieldSelectedValue) => {
    if (event.FieldName === FieldNames.Venue) {
      const startDateField = this.filterSchema.FieldsArray.find((field) => field.fieldName === FieldNames.IltPartStartDate);
      if (startDateField) {
        const selectedVenue = event.Value;
        if (selectedVenue && selectedVenue !== '') {
          const venueDates = this.datesByVenue[selectedVenue];
          if (venueDates && venueDates.length > 0) {
            startDateField.options = venueDates.map((dateItem: any) => ({
              fieldLabel: `${dateItem.date} (${dateItem.count})`,
              fieldValue: dateItem.date,
            }));
            startDateField.disabled = false;
          } else {
            startDateField.options = [];
            startDateField.disabled = true;
          }
          startDateField.selectedValue = '';
        } else {
          startDateField.options = [];
          startDateField.selectedValue = '';
          startDateField.disabled = true;
        }
      }
    }
    this.checkForAnyEmptyFields();
  };
}
